import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { borderRadiusBox } from 'components/AppTheme/index';

interface Props {
  mobileBreak?: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: Props) => ({
      marginBottom: theme.spacing(2),
      borderRadius: borderRadiusBox,
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
      },
      [`@media (max-width: ${props.mobileBreak || 0}px)`]: {
        '& span:not(.active) .MuiStepLabel-labelContainer': { display: 'none'}
      }
    }),
    button: {
      '@media (max-width: 800px)': {
        '& .MuiTypography-body2': { fontSize: '12px' }
      }
    },

  }),
);

export default useStyles;
